import { useState } from 'react';

export const usePermissionsService = ({ onSuccess }: { onSuccess: () => void }) => {
  const [permissionState, setPermissionState] = useState<PermissionState | null>(null);

  const checkPermissions = async (names: ('camera' | 'microphone')[]) => {
    let statuses: PermissionStatus[] = [];
    try {
      statuses = await Promise.all(names.map((name) => navigator.permissions.query({ name: name as PermissionName })));
    } catch (e) {
      console.error(e);
    }

    const allGranted = statuses.every((status) => status.state === 'granted');
    if (allGranted) {
      onSuccess();
    } else {
      const notGranted = statuses.find((status) => status.state !== 'granted');
      setPermissionState(notGranted?.state || null);
    }
  };

  const requestPermissions = async (mediaConstraints: MediaStreamConstraints) => {
    try {
      const mediaStream = await window.navigator.mediaDevices.getUserMedia(mediaConstraints);
      if (mediaStream.active) {
        const tracks = mediaStream.getTracks();
        tracks.forEach((track) => track.clone().stop());

        onSuccess();
      }
    } catch (e: any) {
      if (e.name === 'NotAllowedError') {
        setPermissionState('denied');
      }
    }
  };

  return {
    permissionState,
    checkPermissions,
    requestPermissions
  };
};
